<template>
    <div class="flex flex-col sm:flex-row -mx-2 flex-wrap"  data-type="Services">
        <!-- <label v-text="field.label" class="block text-center w-full mb-8"></label> -->
        <div
            v-for="(choice, choice_key) in field.choices"
            :key="choice_key"
            class="mb-4 px-2 sm:w-1/2 lg:w-1/4"
            role="radiogroup"
        >
            <label
                :for="`field_${field.id}_${choice_key}`"
                class="border border-solid border-secondary-nonbinary-300 hover:shadow-md p-10 rounded h-full cursor-pointer flex flex-col justify-center items-center font-medium"
                :class="[$store.state.data[field.id] == choice.value ? `${$store.state.configs.button} text-white` : '']"
                @click="selectService(choice)"
                tabindex="0"
                role="switch"
                :aria-checked="$store.state.data[field.id] == choice.value"
                @keypress.prevent="e => {
                    if([32,13].includes(e.keyCode)) e.target.click();
                }"
            >
                <i 
                    class="fal fa-2x mb-4"
                    :class="{
                        'fa-monitor-heart-rate' : choice.value == 'medical',
                        'fa-smile' : choice.value == 'behavioral',
                        'fa-spa' : choice.value.indexOf('spa') !== -1,
                        'fa-heart ' : choice.value == 'adoption',
                        'fa-calendar-check' : !['medical','adoption','behavioral'].includes(choice.value) && choice.value.indexOf('spa') === -1
                    }"
                ></i>

                <span class="text-center text-xl" v-text="choice.text"></span>
            </label>
            <input
                    :id="`field_${field.id}_${choice_key}`"
                    type="radio"
                    :class="'hidden ' + field.cssClass"
                    aria-hidden="true"
                    style="display: none;"
                    :name="field.id"
                    :required="field.isRequired"
                    :value="choice.value"
                    v-model="fields[field.id]"
                />
        </div>
    </div>
</template>

<script>
export default {
    props: ["field", "fields"],
    methods: {
        selectService(c) {
            if(c.value.indexOf('http') !== -1) {
                this.$router.push(c.value);
                return;
            }
            this.fields[this.field.id] = c.value;

            this.$emit("next");
        },
    },
};
</script>